// Hex-tile positions for European countries.
// Grid coords (col, row). Converted to pixel positions with hex layout.
// Layout approximates geography for quick visual scan.

export const EU_HEX = [
  // name, iso, col, row, csv-country-key
  { name: "Iceland",     iso: "IS", col: 0, row: 0, key: "Iceland" },
  { name: "Norway",      iso: "NO", col: 5, row: 0, key: "Norway" },
  { name: "Sweden",      iso: "SE", col: 6, row: 0, key: "Sweden" },
  { name: "Finland",     iso: "FI", col: 7, row: 0, key: "Finland" },

  { name: "Ireland",     iso: "IE", col: 2, row: 2, key: "Ireland" },
  { name: "Scotland",    iso: "UK-SCT", col: 3, row: 1, key: "United Kingdom - Scotland" },
  { name: "N. Ireland",  iso: "UK-NIR", col: 2, row: 1, key: "United Kingdom - Northern Ireland" },
  { name: "Estonia",     iso: "EE", col: 7, row: 1, key: "Estonia" },
  { name: "Latvia",      iso: "LV", col: 7, row: 2, key: "Latvia" },

  { name: "Wales",       iso: "UK-WLS", col: 3, row: 3, key: "United Kingdom - Wales" },
  { name: "England",     iso: "UK-ENG", col: 4, row: 2, key: "United Kingdom - England" },
  { name: "Netherlands", iso: "NL", col: 5, row: 2, key: "Netherlands" },
  { name: "Denmark",     iso: "DK", col: 5, row: 1, key: "Denmark" },
  { name: "Lithuania",   iso: "LT", col: 7, row: 3, key: "Lithuania" },

  { name: "France",      iso: "FR", col: 4, row: 4, key: "France" },
  { name: "Belgium",     iso: "BE", col: 5, row: 3, key: "Belgium" },
  { name: "Luxembourg",  iso: "LU", col: 5, row: 4, key: "Luxembourg" },
  { name: "Germany",     iso: "DE", col: 6, row: 3, key: "Germany" },
  { name: "Poland",      iso: "PL", col: 7, row: 4, key: "Poland" },
  { name: "Czechia",     iso: "CZ", col: 6, row: 4, key: "Czechia" },

  { name: "Portugal",    iso: "PT", col: 2, row: 6, key: "Portugal" },
  { name: "Spain",       iso: "ES", col: 3, row: 6, key: "Spain" },
  { name: "Switzerland", iso: "CH", col: 5, row: 5, key: "Switzerland" },
  { name: "Austria",     iso: "AT", col: 6, row: 5, key: "Austria" },
  { name: "Slovakia",    iso: "SK", col: 7, row: 5, key: "Slovakia" },
  { name: "Hungary",     iso: "HU", col: 8, row: 5, key: "Hungary" },
  { name: "Moldova",     iso: "MD", col: 9, row: 5, key: "Moldova" },

  { name: "Italy",       iso: "IT", col: 5, row: 6, key: "Italy" },
  { name: "Slovenia",    iso: "SI", col: 6, row: 6, key: "Slovenia" },
  { name: "Croatia",     iso: "HR", col: 7, row: 6, key: "Croatia" },
  { name: "Bosnia & H.", iso: "BA", col: 7, row: 7, key: "Bosnia & Herzegovina" },
  { name: "Serbia",      iso: "RS", col: 8, row: 6, key: "Serbia" },
  { name: "Romania",     iso: "RO", col: 9, row: 6, key: "Romania" },
  { name: "Bulgaria",    iso: "BG", col: 9, row: 7, key: "Bulgaria" },

  { name: "Montenegro",  iso: "ME", col: 8, row: 7, key: "Montenegro" },
  { name: "Kosovo",      iso: "XK", col: 9, row: 8, key: "Kosovo" },
  { name: "Albania",     iso: "AL", col: 8, row: 8, key: "Albania" },
  { name: "N. Macedonia",iso: "MK", col: 8, row: 9, key: "North Macedonia" },
  { name: "Greece",      iso: "GR", col: 9, row: 9, key: "Greece" },

  { name: "Malta",       iso: "MT", col: 6, row: 9, key: "Malta" },
  { name: "Cyprus",      iso: "CY", col: 11, row: 9, key: "Cyprus" },

  // Added as Baserow country options (east / south-east of the grid).
  { name: "Ukraine",     iso: "UA", col: 10, row: 4, key: "Ukraine" },
  { name: "Turkey",      iso: "TR", col: 10, row: 8, key: "Turkey" },
];

// Convert hex grid (col,row) → pixel (x,y) with staggered layout
export function hexToPx(col, row, radius = 42) {
  const dx = radius * Math.sqrt(3);
  const dy = radius * 1.5;
  const xOff = (row % 2 === 1) ? dx / 2 : 0;
  return { x: col * dx + xOff + radius * 1.5, y: row * dy + radius * 1.5 };
}
